import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { FacilityForwarder } from '../models/facility-forwarder';

@Injectable({
  providedIn: 'root'
})
export class FacilityService {
  getImportExportLicenceApplyInfoList(language: string) {
    throw new Error('Method not implemented.');
  }

  constructor(private http: HttpClient) { }

  /**
   * Get facility dropdown list options by country name.
   * @param countryName Country name
   */
  getFacilityOptions(countryName?: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/facilityoptions/${isNullOrEmpty(countryName) ? '' : countryName}`;
    return this.http.get(url);
  }

  getAccountOptions(facilityCode?: string, optionType?: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/option/${optionType}?facilityCode=${facilityCode}`
    return this.http.get(url);
  }

  /**
   * Get forwarder dropdown list options by facility code.
   * @param facilityCode Facility code
   */
  getForwarderOptions(facilityCode: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/forwarderoptions/${facilityCode}`;
    return this.http.get(url);
  }

    /**
   * Get forwarder dropdown list options by facility code.
   * @param facilityCode Facility code
   */
    getAllForwarderOptions(): Observable<any> {
      const url = `${environment.logisticsApiUrl}/facility/getAllForwarderOptions`;
      return this.http.get(url);
    }

  /**
   * Get car seq dropdown list options by facility code.
   * @param facilityCode Facility code
   */
  getCarSeqOptions(facilityCode: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/carseqoptions/${facilityCode}`;
    return this.http.get(url);
  }

  /**
   * Get car type dropdown list options.
   */
  getCarTypeOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/cartypeoptions`;
    return this.http.get(url);
  }

  /**
   * Get letter org dropdown list options.
   */
  getLetterOrgOptions(facility: string, orgId?: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/letterorgoptions/${facility}?orgId=${orgId}`;
    return this.http.get(url);
  }

  /**
   * Get region dropdown list options.
   */
  getArea(facility: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/RFQ/RFQArea/${facility}`;
    return this.http.get(url);
  }

  /**
   * Get forwarder account by giving facility and forwarder name.
   * @param facility Facility code
   * @param forwarderName Forwarder name
   */
  getAccountIdOptions(facility: string, forwarderName: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/accountOption/${facility}/${forwarderName}`;
    return this.http.get(url);
  }

  /**
   * Get incoTerm dropdown list options
   */
  getIncoTermOption(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/incotermOption`;
    return this.http.get(url);
  }

  /**
   * Get pickup location dropdown list options by facility code.
   * @param facilityCode Facility code
   */
  getPickupLocationOptions(facilityCode: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/pickupLocationOption/${facilityCode}`;
    return this.http.get(url);
  }

  /**
   * Get delivery type by giving Input/Output type.
   * @param IOType Input/Output
   */
  getDeliveryTypeOptions(IOType: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/deliveryTypeOption/${IOType}`;
    return this.http.get(url);
  }

  /**
   * Get delivery sub-type by giving Input/Output type.
   * @param IOType Input/Output
   */
  getDeliverySubTypeOptions(IOType: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/deliverySubTypeOption/${IOType}`;
    return this.http.get(url);
  }

  /**
   * Get facility forwarder express info.
   * @param facility Facility code
   * @param forwarder Forwarder name
   */
  getFacilityForwarderExpressInfo(facility: string, forwarder: string) {
    const url = `${environment.logisticsApiUrl}/facility/forwarder/expressinfo/${facility}/${forwarder}`;
    return this.http.get(url);
  }

  /**
   * get org Id options
   */
  getOrgIdOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/orgIdOption`;
    return this.http.get(url);
  }

  /**
   * get export status by facility
   * @param facility facility
   */
  getExportStatusOptions(facility: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/exportStatusOptions/${facility}`;
    return this.http.get(url);
  }

  /**
   * get Bill Object Options By facility
   */
  getBillObjectOptions(facility: string, billObjectType: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/billObjectOptions/${facility}/${billObjectType}`;
    return this.http.get(url);
  }

  /**
   * get BillObjectType options
   */
  getBillObjectTypeOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/billObjectTypeOption`;
    return this.http.get(url);
  }

  /**
   * get ShipMethod options
   */
  getShipMethodOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/shipMethodOption`;
    return this.http.get(url);
  }

  /**
   * get docType Options
   */
  getDocTypeOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/docTypeOption`;
    return this.http.get(url);
  }

  getDocTypeOptionsByFacilityCode(facilityCode: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/docTypeOption/${facilityCode}`;
    return this.http.get(url);
  }

  /**
   * get docType1 Options
   */
  getDocType1Options(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/docType1Option`;
    return this.http.get(url);
  }

  /**
   * get Currency Options
   */
  getCurrencyOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/currencyOption`;
    return this.http.get(url);
  }

  /**
   * get Export Code Options By Facility
   * @param facility
   */
  getExportCodeOptions(facility: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/exportCodeOptions/${facility}`;
    return this.http.get(url);
  }


  /**
   * get country data
   */
  getCountryOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/countryOptions`;
    return this.http.get(url);
  }

  /**
 * get city data
 * @param country
 */
  getCityOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/cityOptions`;
    return this.http.get(url);
  }

  /**
   * get area data
   */
  getAllAreaOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/RFQ/areaOptions`;
    return this.http.get(url);
  }

  /**
* get city data
* @param country
*/
  getAirPortOptions(citySeq: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/airPortOptions/${citySeq}`;
    return this.http.get(url);
  }


  /*
* get ImportDeclarationStatus data
* @param ImportDeclarationStatus
*/
  getImportDeclarationStatusOptions(facilityCode: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/ImportDeclarationStatus/${facilityCode}`;
    return this.http.get(url);
  }

  /**
  * get ImportDocType data
  * @param ImportDocType
  */
  getImportDocTypeOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/docType`;
    return this.http.get(url);
  }

  getBrandOptions(isActivated: Number): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/brand/${isActivated}`;
    return this.http.get(url);
  }

  getFacilityOptionsByFacilityCode(facilityCode?: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/getFacilityOptionsByFacilityCode/${facilityCode}`;
    return this.http.get(url);
  }

  getVendorOptions(key?: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/vendor`;
    return this.http.post(url, key);
  }

  getAllVendorOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/vendorOptions`;
    return this.http.get(url);
  }

  getAllVendorOrConsigneeOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/vendorOrConsigneeOptions`;
    return this.http.post(url, null);
  }

  getPickupLocationOptionByDefault(facilityCode: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/pickupLocationOptionByDefault/${facilityCode}`;
    return this.http.get(url);
  }

  getImportTypeOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/importType`;
    return this.http.get(url);
  }

  /**
  * get SourceType data
  */
  getSourceTypeOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/import/ad/sourceType`;
    return this.http.get(url);
  }

  /**
   * get tiem zone
   */
  getTimeZone(facility: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/getTimeZone/${facility}`;
    return this.http.get(url, { responseType: 'text' });
  }
  /**
 * get airport Data
 */
  async getAirPortOptionsAsync(citySeq: string): Promise<any> {
    const url = `${environment.logisticsApiUrl}/facility/airPortOptions/${citySeq}`;
    return this.http.get(url).toPromise();
  }


  getFacilityLocation(facility: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/getFacilityLocation/${facility}`;
    return this.http.get(url);
  }

  getFlowBillTypeOption(facility: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/flowBillTypeOption/${facility}`;
    return this.http.get(url);
  }

  getExpenseOptions(optionType: String, optionCode: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/common/findFacilityOptionsByOptionTypeAndOptionCode/${optionType}${isNullOrEmpty(optionCode) ? '' : '?optionCode=' + optionCode}`;
    return this.http.get(url);
  }

  getAccountCodeOptions(optionType?: string, facilityCode?: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/getAccountCodeOption/${optionType}?facilityCode=${facilityCode}`;
    return this.http.get(url);
  }

  getOptions(facilityCode?: string, optionType?: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/option/${optionType}?facilityCode=${facilityCode}`
    return this.http.get(url);
  }

  getAllFacilityOptions(OptionType?: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/all/facilityOptions/${OptionType}`
    return this.http.get(url);
  }

  getCityOptionsByCountry(country: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/getCityByCountry/${country}`;
    return this.http.get(url);
  }

  getAllFacilityOptionsByOptionType(optionType: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/all/facilityOptions/${optionType}`;
    return this.http.get(url);
  }

  getShipToOptionsByConsigneeKey(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/merge/findShipToOptionsByConsigneeKey`;
    return this.http.post(url, request);
  }

  getCsrOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/merge/findCsrOptions`;
    return this.http.get(url);
  }

  getTenantOrgOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/TenantOrg/getTenantOrgOptions`;
    return this.http.get(url);
  }

  getPcsrOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/employee/findPcsrOptions`;
    return this.http.get(url);
  }

  getPcsrAndCsrOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/employee/findPcsrAndCsrOptions`;
    return this.http.get(url);
  }

  getTaskCodeOptions(category: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/findTaskCodeOptions/${category}`;
    return this.http.get(url);
  }

  getWaitingReferenceOption(facility: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/doAbnormal/getWaitingReferenceOption?facility=${facility}`;
    return this.http.get(url);
  }
  getAddressCategory(facilityCode: string, lang: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/getAddressCategory/${facilityCode}/${lang}`;
    return this.http.get(url);
  }
  getOrgOptionsByWhDetail(facility:string , whno:string ): Observable<any>{
    const url = `${environment.logisticsApiUrl}/TenantOrg/getOrgOptionsByWhDetail/${facility}/${whno}`;
    return this.http.get(url);
  }

  getTaskCodeOptionsForDoSearch(category: String): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility/findTaskCodeOptionsForDoSearch/${category}`;
    return this.http.get(url);
  }

  getFacilityPickupLocationCode(facility:string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/facility/getFacilityPickupLocationCode/${facility}`;
    return this.http.get(url);
  }

  getFacilityForwarder(): Observable<FacilityForwarder[]> {
    const url = `${environment.logisticsApiUrl}/facilityForwarder/all`;
    return this.http.get<FacilityForwarder[]>(url);
  }
}
